import React from "react";
import { Helmet } from "react-helmet-async";
import { Trans, useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {makeStyles} from '@mui/styles';

import { Link } from "../../helpers/multilingual";
const useStyleErrorPage = makeStyles(theme => ({
  root: {
    paddingBottom: 40,
  },
  pageTitle: {
    paddingBottom: 30,
    '& h1': {
      fontWeight: 'bold',
      marginBottom: 5
    },
    '& .MuiIconButton-root': {
      padding: 11
    },
    [theme.breakpoints.down('sm')]: {
      //paddingTop: 0,
    },
  },
}));

const ErrorPage = () => {

  const classes = useStyleErrorPage();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{t("pageNotFound")}</title>
        <meta property="og:title" content={t("pageNotFound")}/>
      </Helmet>
      <Container fixed maxWidth="xxl" sx={{pt: {xs: 0, sm: '11vw'}}}>
        <div className={classes.pageTitle}>
          <Grid container justify={"space-between"}>
            <Grid item>
              <Typography component="h1" variant="h4" color={"primary"}>
                {t("pageNotFound")}
              </Typography>
            </Grid>
          </Grid>
        </div>
        <Grid container className={classes.content} alignItems={"center"} justify={"center"}>
          <Grid item xs={12} sm={6}>
            <Typography component={"div"} align={"center"}>
              <img src={`${process.env.REACT_APP_API_RESOURCES_URL}/images/page-not-found.png`} alt=""/>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography component={"h4"} variant={"h5"}>
                  <Trans i18nKey={"pageNotFoundDescription1"}>The page you are looking for is not available at this moment</Trans>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <Trans i18nKey={"pageNotFoundDescription2"}>You can return to the home page or contact our team</Trans>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={4}>
                  <Grid item>
                    <Button variant={"outlined"} component={Link} to={""}>
                      <Trans i18nKey={"homepage"}>Homepage</Trans>
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant={"outlined"} component={Link} to={"/contact"}>
                      <Trans i18nKey={"contact"}>Contact</Trans>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ErrorPage;
